import * as e from "react";
const d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 10-16 0 8 8 0 0016 0zm2 0c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.012 9.068a3.5 3.5 0 013.373-.963 3.446 3.446 0 012.506 2.465 3.391 3.391 0 01-.988 3.348l-3.616 3.554v.002a1.831 1.831 0 01-2.573 0l-.002-.002-3.615-3.554a3.391 3.391 0 01-.988-3.348 3.446 3.446 0 012.506-2.465 3.5 3.5 0 013.372.963L12 9.08l.012-.012zm-1.461 1.392a1.5 1.5 0 00-1.45-.415 1.446 1.446 0 00-1.056 1.03 1.392 1.392 0 00.416 1.38l.013.012L12 15.933l3.526-3.466.013-.012c.39-.356.545-.886.416-1.38a1.446 1.446 0 00-1.056-1.03 1.5 1.5 0 00-1.45.415l-.012.012L12 11.882l-1.437-1.41-.012-.012z",
      fill: "#2d6ded"
    }
  )
);
export {
  d as default
};
